import { useNavigate } from '@web/Router/router.hooks';
import { useConversationState } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { useLeaveConversation } from '@web/conversations/hooks/useLeaveConversation';

export const useLeaveConversationModal = () => {
  const navigate = useNavigate();
  const { mutateAsync } = useLeaveConversation();
  const { id } = useConversationState();

  const onSubmit = async () => {
    await mutateAsync({ id });
    navigate.toConversationRoot();
  };

  return {
    onSubmit,
  };
};
